import { graphql, useStaticQuery } from 'gatsby';
import { withExternalLogos } from '@lucid/utils';

import type { Lucid } from '../types/types';

const useExternalLogos = (logos: string[]): Lucid.Directus.Generated.External_Logo[] => {
  const { directus } = useStaticQuery<Lucid.Query.Hooks.UseExternalLogos>(graphql`
    query useExternalLogosQuery {
      directus {
        external_logo {
          name
          image {
            filename_disk
            uploaded_on
            translations {
              alt
            }
          }
        }
      }
    }
  `);

  return withExternalLogos(logos, directus.external_logo);
};

export default useExternalLogos;
